/*--------------------------------------------------------------
# Custom scripts for In Page Navigation block
--------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
    // Update active link detection
    function updateActiveLink() {
        // Select all sections with an ID
        var sections = document.querySelectorAll('section[id]');
        var windowHeight = window.innerHeight;
        var currentSection = null;

        // Find the section that is most visible
        sections.forEach(function (section) {
            var rect = section.getBoundingClientRect();
            var visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
            var sectionHeight = rect.height;
            var visiblePercentage = (visibleHeight / sectionHeight) * 100;

            if (visibleHeight > 0 && visiblePercentage >= 50) {
                currentSection = section;
            }
        });

        if (currentSection) {
            var sectionId = currentSection.id;

            // Remove active classes from all tab-row and dropdown items
            document.querySelectorAll('.tab-row__item, .dropdown-item').forEach(function (item) {
                item.classList.remove('active-item', 'anchor-active');
            });

            // Update tab-row active link
            var activeTab = document.querySelector(`.tab-row__item[href="#${sectionId}"]`);
            if (activeTab) {
                activeTab.classList.add('active-item', 'anchor-active');
            }

            // Update dropdown active link and label
            var activeDropdown = document.querySelector(`.dropdown-item[href="#${sectionId}"]`);
            if (activeDropdown) {
                activeDropdown.classList.add('active-item');

                var sectionNameLabel = document.querySelector('.section-name-label');
                if (sectionNameLabel) {
                    sectionNameLabel.textContent = activeDropdown.textContent;
                }
            }
        }
    }

    // Throttle function for performance
    function throttle(func, limit) {
        let inThrottle;
        return function () {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                func.apply(context, args);
                inThrottle = true;
                setTimeout(() => (inThrottle = false), limit);
            }
        };
    }

    // Throttled scroll handler
    const throttledUpdateActiveLink = throttle(updateActiveLink, 100);
    window.addEventListener('scroll', throttledUpdateActiveLink);

    // Handle resize events
    let resizeTimeout;
    window.addEventListener('resize', function () {
        if (resizeTimeout) {
            clearTimeout(resizeTimeout);
        }
        resizeTimeout = setTimeout(updateActiveLink, 250);
    });

    // Initial check
    updateActiveLink();
});


/*--------------------------------------------------------------
# Custom scripts for In Anchor Navigation block
--------------------------------------------------------------*/

	// /* Auto-select the dropdown menu item dependent on what page section you are viewing ( mobile ) */
	// window.addEventListener( 'scroll', function(ev) {
	// 	for ( let i = 1; i < document.getElementsByClassName('dropdown-menu')[2].getElementsByClassName("dropdown-item").length + 1; i++ ) {
	// 	   if ( document.getElementById( 'block_' + [i] ) ) {
	// 		  let blockObj = document.getElementById( 'block_' + [i] )
	// 		  let distanceToTop = blockObj.getBoundingClientRect().top
	// 		  if ( ( document.getElementById( 'block_' + [i] ).getBoundingClientRect().top ) < 120 ) {
	// 			  let viewItemText = document.getElementsByClassName('dropdown-menu')[2].getElementsByClassName("dropdown-item")[i-1].text
	// 			   document.getElementsByClassName('dropdown-toggle')[2].getElementsByClassName('section-name-label')[0].innerHTML = viewItemText
	// 		  }
	// 	   }
	 
	// 	} 
	// })
	
	// /* Auto-select the dropdown menu item dependent on what page section you are viewing ( desktop ) */
	// if ( document.getElementById( 'block_1' ) ) {
	// 	if ( document.getElementsByClassName( 'tab-row__item')[0] ) {
	// 		document.getElementsByClassName( 'tab-row__item')[0].style.border ='1px solid white'
	// 	}   
	// }
	// window.addEventListener( 'scroll', function( ev ) {
	// 	let verticalDirection = ( this.oldScroll > this.scrollY ) ? 'up' : 'down' 
	// 	for ( let i = 1; i < document.querySelectorAll( '.tab-row__item' ).length+1; i++ ) {
	// 	   if ( document.getElementById( 'block_' + [i] ) ) {
	// 			let headerheight = document.querySelector('.in-page-nav').clientHeight
	// 							 + document.querySelector('.header').clientHeight
	// 			let heightFromTop = ( verticalDirection == 'down' ) 
	// 								? headerheight 
	// 								: document.querySelector('#block_' + [i]).offsetHeight + headerheight
									
	// 			if ( document.getElementById( 'block_' + [i] ) && document.getElementById( 'block_' + [i] ).getBoundingClientRect().top < heightFromTop - 120 ) {
	// 				if ( i !== 1 && document.getElementsByClassName( 'tab-row__item')[i-2] ) {
	// 					 document.getElementsByClassName( 'tab-row__item')[i-2].style.border = 'unset';
	// 				}
	// 				if ( document.getElementsByClassName( 'tab-row__item')[i-1] ) {
	// 					 document.getElementsByClassName( 'tab-row__item')[i-1].style.border ='1px solid white'

	// 					let index = document.getElementsByClassName( 'tab-row__item')[i-1].getAttribute('data-slick-index')
	// 					tabSlider.slickGoTo(index);
	// 				}
	// 			} 
	// 			else {
	// 				if ( document.getElementsByClassName( 'tab-row__item')[i-1] ) {
	// 					 document.getElementsByClassName( 'tab-row__item')[i-1].style.border = 'unset';
	// 				}            
	// 			}

	// 			if ( document.getElementById( 'block_1' ) && document.getElementById( 'block_1' ).getBoundingClientRect().top < 600 ) {
	// 				if ( document.getElementsByClassName( 'tab-row__item')[0] ) {
	// 					document.getElementsByClassName( 'tab-row__item')[0].style.border ='1px solid white'

	// 					let index = document.getElementsByClassName( 'tab-row__item')[i-1].getAttribute('data-slick-index')
	// 					tabSlider.slickGoTo(index);
	// 				}   
	// 			}

	// 			if ( document.getElementById( 'block_2' ) && document.getElementById( 'block_2' ).getBoundingClientRect().top < heightFromTop - 120 ) {
	// 				if ( document.getElementsByClassName( 'tab-row__item')[0] ) {
	// 					document.getElementsByClassName( 'tab-row__item')[0].style.border ='unset'
	// 				}   
	// 			}

	// 			// get data attribute for active slide
	// 	   }
	// 	} 
	// 	this.oldScroll = this.scrollY;
	//  });
	
// });
